import { filterIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Filter2 = createIcon({
  displayName: 'Filter2',
  paths: [
    'M822.187 259.84c18.347-25.173 20.907-58.453 6.827-86.187-14.080-28.16-42.667-45.227-73.813-45.227h-486.4c-31.147 0-59.733 17.493-73.813 45.227s-11.52 61.013 6.827 86.187l187.307 256.426v306.773c0 29.44 17.493 55.893 44.8 67.413 8.96 3.84 18.773 5.547 28.16 5.547 18.773 0 37.547-7.253 51.627-21.333l97.707-97.707c15.787-15.787 24.32-36.267 24.32-58.453v-200.533l186.453-258.133zM566.187 467.627c-10.24 14.080-16.213 31.147-16.213 48.64l0.853 200.107-76.373 76.373v-276.907c0-17.493-5.547-34.56-15.787-48.64l-185.173-253.866 478.293-1.28-185.6 255.573z'
  ],
  canvasPaths: canvasIconPaths(filterIcon)
})
